import React, { FC } from 'react'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import moment from 'moment/moment'
import { Button, FormInput } from '@microservices/wiskey-react-components'
import { Grid } from '@mui/material'

import { buttonStylesByMode, generalFieldStylesByMode } from '@helpers'
import { GENERATOR_INPUT_TYPE } from '@constants'

import { useHandlers } from '../../hooks/useHandlers'

type FiltersType = {
  isShowTimeIntervalFilter?: boolean
  watchDateRange: string[]
  onSearchClick: () => void
  methods: ReturnType<typeof useHandlers>['state']['methods']
  onResetFilters: () => void
  isFiltersChanged: boolean
}

export const Filters: FC<FiltersType> = props => {
  const {
    isShowTimeIntervalFilter,
    watchDateRange,
    onSearchClick,
    methods,
    onResetFilters,
    isFiltersChanged,
  } = props

  const { t } = useTranslation()

  const handleResetFilters = () => {
    onResetFilters()
  }

  if (!isShowTimeIntervalFilter) {
    return null
  }

  return (
    <>
      <FormProvider {...methods}>
        <FormInput
          dateTimePickerViews={['day']}
          formatDate={'DD.MM.YYYY'}
          inputType={GENERATOR_INPUT_TYPE.DATE_RANGE_PICKER}
          name='dateRange'
          value={watchDateRange}
          rangeDatePickerProps={{
            start: {
              maxDate: moment(watchDateRange[1]),
            },
            end: {
              minDate: moment(watchDateRange[0]),
            },
          }}
          sx={theme => ({
            ...generalFieldStylesByMode(theme),
          })}
        />
      </FormProvider>
      <Grid item alignSelf={'flex-end'} mb={2}>
        <Button
          disabled={!isFiltersChanged}
          sx={theme => buttonStylesByMode(theme, true)}
          variant='text'
          onClick={handleResetFilters}
        >
          {t('filter.reset')}
        </Button>
        <Button
          disabled={!watchDateRange[0] || !watchDateRange[1]}
          sx={theme => buttonStylesByMode(theme, true)}
          variant='text'
          onClick={onSearchClick}
        >
          {t('filter.search')}
        </Button>
      </Grid>
    </>
  )
}
